import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const FilterTitle = styled.h2`
  margin-top: 3px !important;
  font-size: 22px;
  color: #4a4a4a;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    font-size: 18px !important;
  }
`

export default FilterTitle
